import { Popover, IconButton, Box, Tooltip } from "@mui/material";
import React, {
  useState,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import FormatColorFillIcon from "@mui/icons-material/FormatColorFill";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";

const SelectColorBox = forwardRef(
  ({ color, onChange, type, onKeyDown, isDisabled }, ref) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedColorIndex, setSelectedColorIndex] = useState(0);
    const popoverRef = useRef();
    const IconButtonRef = useRef();
    const firstColorRef = useRef();

    useImperativeHandle(ref, () => ({
      focus: () => {
        IconButtonRef.current?.focus(); // Adjust if there's a specific element to focus
      },
      firstRef: IconButtonRef.current,
    }));

    const handlePopoverOpen = (event) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
      setTimeout(() => {
        firstColorRef?.current?.focus(); // Move focus to the first color option
      }, 0);
    };

    const handlePopoverClose = (event) => {
      event.stopPropagation();
      setAnchorEl(null);
      setTimeout(() => {
        IconButtonRef.current?.focus(); // Move focus to the first color option
      }, 0);
    };

    const handleColorSelect = (event, color) => {
      event.stopPropagation();
      event.preventDefault();
      onChange(color);
      handlePopoverClose(event);
    };

    const bgColors = ["none", "#a5cff3", "#d2fdd7", "#febfbf"];
    const fgColors = ["black", "blue", "green", "red"];
    const colors = type === "bgColor" ? bgColors : fgColors;
    const handleArrowKeyNavigation = (event) => {
      if (event.key === "Enter") {
        if (!anchorEl) {
          handlePopoverOpen(event);
        }

        else {
          handlePopoverClose(event)
        }

      }
    }
    const handleArrowKeyNavigation1 = (event) => {
      let newIndex = selectedColorIndex;

      if (event.key === "ArrowDown") {
        newIndex = (selectedColorIndex + 1) % colors.length;
        setSelectedColorIndex(newIndex);
        event.preventDefault();
      } else if (event.key === "ArrowUp") {
        newIndex = (selectedColorIndex - 1 + colors.length) % colors.length;
        setSelectedColorIndex(newIndex);
        event.preventDefault();
      } else if (event.key === "Enter") {
        if (anchorEl) {
          // If popover is open, select the color
          handleColorSelect(event, colors[selectedColorIndex]);
        } else {
          // If button is focused, open the popover
          handlePopoverOpen(event);
        }
        return; // Exit the function to prevent additional changes
      }
    };
    return (
      <div ref={popoverRef}>
        <IconButton
          onClick={handlePopoverOpen}
          ref={IconButtonRef}
          onKeyDown={(event) => {
            handleArrowKeyNavigation(event);
            if (onKeyDown) onKeyDown(event, colors[selectedColorIndex]);
          }}
          disabled={isDisabled}
        >
          <Tooltip
            title={type === "bgColor" ? "Background Color" : "Foreground Color"}
          >
            {type === "bgColor" ? (
              <FormatColorFillIcon
                style={{ color: isDisabled ? "rgba(0, 0, 0, 0.28)" : color === "none" ?  "#000" : color }}
              />
            ) : (
              <FormatColorTextIcon
                style={{ color: isDisabled ? "rgba(0, 0, 0, 0.28)" : color === "none" ? "#000" : color }}
              />
            )}
          </Tooltip>
        </IconButton>
        <Popover
          open={Boolean(anchorEl)}
          sx={{
            borderRadius: "6px",
          }}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          container={popoverRef.current} // Attach popover to ref
          onKeyDown={(event) => {
            handleArrowKeyNavigation1(event);
          }}
        >
          <Box
            sx={{ display: "flex", flexDirection: "column", padding: "5px" }}
          >
            {(type === "bgColor" ? bgColors : fgColors).map((clr, index) => (
              <Box
                key={clr}
                ref={index === 0 ? firstColorRef : null} // Attach ref to the first color option
                tabIndex={index === selectedColorIndex ? 0 : -1} // Make the selected color focusable

                onClick={(event) => handleColorSelect(event, clr)}

                sx={{
                  width: "24px",
                  height: "24px",
                  backgroundColor: clr === "none" ? "transparent" : clr,
                  border: clr === "none" ? "1px solid black" : "none",
                  cursor: "pointer",
                  margin: "2px",
                  outline: index === selectedColorIndex ? "2px solid blue" : "none", // Indicate selection

                }}
              />
            ))}
          </Box>
        </Popover>
      </div>
    );
  }
);

export default SelectColorBox;
